document.addEventListener('DOMContentLoaded', function() {
    const youtubeFacades = document.querySelectorAll('.promo-youtube-facade');
    const mp4Facades = document.querySelectorAll('.promo-mp4-facade');

    // Handle YouTube Videos
    youtubeFacades.forEach(function(facade) {
        const youtubeUrl = facade.dataset.youtubeUrl;
        const videoId = getYoutubeVideoId(youtubeUrl);

        if (videoId) {
            facade.addEventListener('click', function() {
                const iframe = document.createElement('iframe');
                iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
                iframe.setAttribute('frameborder', '0');
                iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
                iframe.setAttribute('allowfullscreen', '');
                facade.parentNode.replaceChild(iframe, facade);
            });
        }
    });

    function getYoutubeVideoId(url) {
        const match = url.match(/(?:https?:\/\/(?:www\.)?youtube\.com\/(?:embed\/|.*[?&]v=)|https?:\/\/(?:www\.)?youtu\.be\/)([^&#]+)/);
        return match ? match[1] : null;
    }

    // Handle MP4 Video Files
    mp4Facades.forEach(function(facade) {
        const mp4Url = facade.dataset.mp4Url;

        if (mp4Url) {
            facade.addEventListener('click', function() {
                const videoElement = document.createElement('video');
                videoElement.setAttribute('controls', '');
                videoElement.setAttribute('autoplay', '');
                videoElement.setAttribute('width', '100%');
                videoElement.setAttribute('height', '100%');

                const sourceElement = document.createElement('source');
                sourceElement.setAttribute('src', mp4Url);
                sourceElement.setAttribute('type', 'video/mp4');

                videoElement.appendChild(sourceElement);
                facade.parentNode.replaceChild(videoElement, facade);
            });
        }
    });
});
